$(document).ready(() => {
  const options = {
    searchField: '.zip-code-search',
    defaultBlock: '.default',
    resultsBlock: '.result',
    errorField: '.error'
  };

  const noResult = () => {
    $(options.errorField).show();
  };

  const resetSearch = () => {
    $(options.errorField).hide();
    $(options.defaultBlock).show();
    $(options.resultsBlock).hide();
  };

  const setResult = (store) => {
    $(options.resultsBlock).find('.name').html(store.address);
    $(options.resultsBlock).find('.phone').html(`<a href='tel:${store.phone}'>${store.phone}</a>`);
    $(options.resultsBlock).find('.email').html(`<a href='mailto:${store.email}'>${store.email}</a>`);
  };

  const searchCSV = (zip) => {

    $.getJSON('/actions/postal/postal/find', {'zip': zip}).done((data) => {

      if (data) {
        $(options.errorField).hide();
        $(options.defaultBlock).hide();

        setResult(data);

        $(options.resultsBlock).show();
      } else {
        noResult();
      }

    });

  };

  $(options.searchField).keyup(function () {
    const value = $(this).val();
    if (value.length === 4) {
      searchCSV(value);
    } else {
      resetSearch();
    }
  });
});
